import { createStyles, IconButton, makeStyles, Theme } from '@fluentsms/components';
import { Close } from '@material-ui/icons';
import { SnackbarKey } from 'notistack';
import React, { ReactElement } from 'react';

const useDismissStyles = makeStyles((theme: Theme) =>
  createStyles({
    dismiss: {
      '& svg': {
        height: theme.spacing(2.5),
        width: theme.spacing(2.5),
      },
      marginRight: theme.spacing(1.5),
    },
  }),
);

interface SnackbarCloseButtonProps {
  snackbarId: SnackbarKey;
  onClick: (key: SnackbarKey) => void;
}

export function SnackbarCloseButton({ onClick, snackbarId }: SnackbarCloseButtonProps): ReactElement {
  const classes = useDismissStyles();

  return (
    <IconButton
      data-testid="snackbar-dismiss-button"
      className={classes.dismiss}
      aria-label="dismiss"
      onClick={() => onClick(snackbarId)}
      size="small"
    >
      <Close />
    </IconButton>
  );
}
